export default __webpack_public_path__ + "static/media/FamilyIMG.ed4924d6.JPEG";